var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{class:("" + (_vm.type == 'add' ? 'button-orange-modal' : 'bg-blue')),attrs:{"type":"submit"}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }